import Platform from "nexia_mobile/platform";
import Dispatch from "nexia_mobile/flux_like/dispatch";
import LocalSettings from "nexia_mobile/models/local_settings";
import { getLanguageSet } from "nx-components/Locales";

function addHeadersToRequest(xhr) {
  let appVersion = Platform.getAppInfo().app_version;
  if (appVersion) {
    xhr.setRequestHeader("X-AppVersion", appVersion);
  }
  let mobileId = LocalSettings.getMobileId();
  if (mobileId) {
    xhr.setRequestHeader("X-MobileId", mobileId);
  }
  let apiKey = LocalSettings.getApiKey();
  if (apiKey) {
    xhr.setRequestHeader("X-ApiKey", apiKey);
  }
}

function urlMatchesMobileAPIHost(url) {
  return url.indexOf(LocalSettings.getHost()) !== -1;
}

const activeRequests = new Set();

export default {
  init: _.once(() => {
    $(document).ajaxSend((event, xhr, options) => {
      if (!activeRequests.has(xhr)) {
        activeRequests.add(xhr);
      }

      xhr.setRequestHeader("Accept", "application/json");
      options.dataType = "json";
      options.timeout = 30000;

      if (urlMatchesMobileAPIHost(options.url)) {
        addHeadersToRequest(xhr);
      }
    });

    $(document).ajaxComplete((event, xhr) => {
      activeRequests.delete(xhr);
    });

    $(document).ajaxError((event, xhr) => {
      const localeSet = getLanguageSet();
      const language = localeSet.nexia_mobile.utils.ajax_hooks;

      activeRequests.delete(xhr);
      if (xhr.statusText === "timeout") {
        Dispatch("NETWORK_REQUEST_TIMEOUT");
      }

      try {
        let data = JSON.parse(xhr.responseText);
        let error = data.error.message;

        if (
          error.match(/mobile.*device.*not.*valid/i) &&
          LocalSettings.isActivated()
        ) {
          Dispatch("SHOW_TOAST", language.reauthenticationToast);
          Dispatch("APP_LOG_OUT", { failedAuthentication: true });
        }
      } catch (error) {
        // ignored
      }
    });
  }),

  abortAllActiveRequests() {
    activeRequests.forEach((xhr) => xhr.abort());
  },
};



// WEBPACK FOOTER //
// ./src/ajax_hooks.js